/* --------------------------------------------------
   GÍO Shopify Chat Widget – FINAL STABLE (SAFE JSON)
--------------------------------------------------- */

(function () {
  "use strict";

  // Do not render chat on checkout or cart
  const path = (window.location && window.location.pathname) || "";
  const isCheckout =
    path.indexOf("/checkouts") === 0 ||
    path.indexOf("/checkout") === 0 ||
    (window.Shopify && Shopify.checkout);
  const isCart = path.indexOf("/cart") === 0;
  if (isCheckout || isCart) return;

  const CHAT_WEBHOOK_URL =
    "https://admindrinkgio.app.n8n.cloud/webhook/957bbdec-8b27-4028-bba3-0d9bbfaf8439/chat";

  const ESCALATION_WEBHOOK_URL =
    "https://admindrinkgio.app.n8n.cloud/webhook/6329e127-70ce-48ba-adfc-bed3cd0aad33";

  const STORAGE = {
    SESSION: "gio_chat_session",
    MESSAGES: "gio_chat_msgs",
    ESCALATION: "gio_chat_escalation",
  };

  /* ================= SAFE JSON ================= */
  const safeParse = (key, fallback) => {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return fallback;
      return JSON.parse(raw);
    } catch {
      localStorage.removeItem(key);
      return fallback;
    }
  };

  /* ================= SESSION ================= */
  const getSessionId = () => {
    let id = localStorage.getItem(STORAGE.SESSION);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(STORAGE.SESSION, id);
    }
    return id;
  };
  const sessionId = getSessionId();

  /* ================= STATE ================= */
  let messages = safeParse(STORAGE.MESSAGES, []);
  let escalation = safeParse(STORAGE.ESCALATION, {
    active: false,
    step: null,
    data: {},
  });

  const resetEscalationFlow = () => {
    escalation = { active: false, step: null, data: {} };
    localStorage.removeItem(STORAGE.ESCALATION);
  };

  resetEscalationFlow();

  const persist = () => {
    localStorage.setItem(STORAGE.MESSAGES, JSON.stringify(messages));
    localStorage.setItem(STORAGE.ESCALATION, JSON.stringify(escalation));
  };

  /* ================= UI ================= */
  const bubbleBtn = document.createElement("button");
  bubbleBtn.className = "chat-bot-bubble";
  bubbleBtn.textContent = "GIÓ";
  Object.assign(bubbleBtn.style, {
    position: "fixed",
    right: "18px",
    bottom: "18px",
    width: "58px",
    height: "58px",
    borderRadius: "30px",
    background: "#0f0f10",
    color: "#fff",
    border: "1px solid #222",
    fontWeight: "700",
    cursor: "pointer",
    zIndex: 2147483647,
    boxShadow: "0 8px 30px rgba(0,0,0,0.6)",
    fontFamily: "Libre Caslon Condensed, serif",
  });
  document.body.appendChild(bubbleBtn);

  const panel = document.createElement("div");
  Object.assign(panel.style, {
    position: "fixed",
    right: "18px",
    bottom: "88px",
    width: "360px",
    height: "520px",
    background: "#0b0b0b",
    color: "#fff",
    borderRadius: "14px",
    border: "1px solid #222",
    display: "none",
    flexDirection: "column",
    overflow: "hidden",
    zIndex: 2147483646,
    fontFamily: "Libre Caslon Condensed, serif",
  });

  panel.innerHTML = `
    <header style="display:flex;justify-content:space-between;align-items:center;padding:14px 16px;border-bottom:1px solid #141414;">
      <div style="display:flex;gap:12px;align-items:center;">
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="36" viewBox="0 0 44 36" fill="none">
<path d="M34.8726 6.587C44.0236 6.01583 43.2781 18.7144 43.0594 24.8565C42.8785 29.9478 42.0276 35.6847 35.8268 35.9823C28.3756 36.3403 27.7295 29.5023 27.5595 23.692C27.3935 18.0225 27.0456 7.07572 34.8735 6.587H34.8726ZM34.8706 6.89069C31.8219 7.30801 31.5038 13.2933 31.3109 15.6664C31.0147 19.3117 30.9571 23.1028 31.1907 26.7571C31.3298 28.9342 31.636 32.8871 33.0087 34.5996C34.2125 36.102 36.5475 36.0255 37.7304 34.5383C39.625 32.1571 39.5306 25.2648 39.5465 22.2219C39.5634 18.9105 39.6011 15.4754 39.0544 12.1851C38.6677 9.85616 37.9014 6.47639 34.8706 6.89169V6.89069Z" fill="white"/>
<path d="M14.8999 35.672C14.391 35.5493 13.8612 35.2637 13.3403 35.1974C12.2191 35.0546 11.0998 35.5835 9.99541 35.7655C4.43879 36.6816 2.00342 34.2954 1.16049 28.9537C0.620731 25.5337 0.727092 21.5234 0.84737 18.0561C1.0591 11.9492 1.84537 6.0796 9.36023 6.5653C10.7071 6.65279 11.9944 7.2129 13.3582 7.12239C13.8691 7.0882 14.2856 6.90519 14.7787 6.81368L11.3254 15.514C11.2539 15.5663 11.0799 15.3994 11.0888 15.3038L11.3284 12.2388C11.235 10.4087 11.395 7.44117 9.14552 6.90519C5.31652 5.99312 4.77975 11.9412 4.54217 14.5044C4.19625 18.2432 4.24695 22.1599 4.41991 25.9007C4.52726 28.2106 4.62666 33.1932 6.26582 34.8786C7.62863 36.2794 9.87315 35.6569 10.7459 34.0148C11.8582 31.9232 11.8642 26.6197 11.559 24.2536C11.3662 22.7573 10.9059 21.3766 9.14353 21.458V21.274H14.898V35.673L14.8999 35.672Z" fill="white"/>
<path d="M25.4382 6.75195V6.99631C24.8538 6.98123 24.1917 7.10693 23.7703 7.54536C23.0377 8.3086 22.818 10.3942 22.7703 11.436C22.4741 17.929 22.9969 24.6504 22.7733 31.1676C22.9502 32.5644 22.979 34.9013 24.647 35.3388C24.7832 35.374 25.3985 35.4102 25.4313 35.4333C25.4691 35.4604 25.5108 35.6666 25.4094 35.6706C25.3876 35.6706 25.308 35.6012 25.2285 35.6093C22.487 35.9079 19.4612 35.5147 16.6838 35.6746C16.0526 35.4232 17.1013 35.3981 17.325 35.3378C19.0178 34.8812 19.0665 32.3994 19.1371 30.9826C19.4512 24.6916 19.0307 18.2408 19.2027 11.9267C19.0804 10.5873 19.0973 7.68916 17.5636 7.15218C17.2296 7.03553 16.8866 7.04357 16.5357 6.99631V6.75296H25.4382V6.75195Z" fill="white"/>
<path d="M41.8498 0.0117188C41.3956 1.93138 40.0695 3.60267 38.2743 4.39004C37.8996 4.55395 37.5 4.68066 37.1113 4.80636C35.3221 5.38557 33.4602 5.7506 31.6779 6.35898L31.5547 6.29261C31.833 5.3363 32.0577 4.46144 32.6054 3.61876C34.7127 0.375741 38.5248 0.82021 41.8498 0.0117188Z" fill="white"/>
</svg>
        <div>
          <div style="font-weight:700;line-height: normal;">Agent</div>
          <div style="font-size:12px;color:#9a9a9a">Online</div>
        </div>
      </div>
      <button id="gio_close" style="background:none;border:none;color:#aaa;font-size:18px;cursor:pointer">✕</button>
    </header>

    <div id="gio_msgs" style="flex:1;overflow:auto;padding:12px;display:flex;flex-direction:column;gap:10px;"></div>

    <div style="padding:12px;border-top:1px solid #141414;display:flex;gap:8px;">
      <input id="gio_input" placeholder="Type your message…" style="flex:1;padding:12px;border-radius:999px;border:1px solid #222;background:#0b0b0b;color:#fff;outline:none" />
      <button id="gio_send" style="padding:10px 14px;border-radius:999px;border:none;background:#111;color:#fff;cursor:pointer">Send</button>
    </div>
  `;
  document.body.appendChild(panel);

  /* ================= RENDER ================= */
  const render = () => {
    const out = panel.querySelector("#gio_msgs");
    out.innerHTML = "";

    messages.forEach((m) => {
      const wrap = document.createElement("div");
      wrap.style.alignSelf = m.role === "user" ? "flex-end" : "flex-start";
      wrap.style.maxWidth = "85%";

      const bubble = document.createElement("div");
      bubble.textContent = m.text;
      Object.assign(bubble.style, {
        padding: "10px 12px",
        borderRadius: "12px",
        fontSize: "14px",
        background: m.role === "user" ? "#fff" : "#111",
        color: m.role === "user" ? "#000" : "#fff",
      });

      wrap.appendChild(bubble);

      // ✅ QUICK REPLIES (only if present)
      if (m.quickReplies && m.quickReplies.length) {
        const qrWrap = document.createElement("div");
        qrWrap.style.display = "flex";
        qrWrap.style.flexWrap = "wrap";
        qrWrap.style.gap = "8px";
        qrWrap.style.marginTop = "8px";

        m.quickReplies.forEach((qr) => {
          const btn = document.createElement("button");
          btn.textContent = qr.label;
          Object.assign(btn.style, {
            padding: "6px 12px",
            borderRadius: "16px",
            border: "1px solid #333",
            background: "#1a1a1a",
            color: "#fff",
            fontSize: "12px",
            cursor: "pointer",
          });

          btn.onclick = () => sendMessage(qr.value || qr.label);
          qrWrap.appendChild(btn);
        });

        wrap.appendChild(qrWrap);
      }

      out.appendChild(wrap);
    });

    out.scrollTop = out.scrollHeight;
  };

  /* ================= ESCALATION ================= */
  const QUESTIONS = {
    name: "What’s your name?",
    email: "What’s the best email to reach you?",
    phone: "What’s your phone number?",
    issue: "Please describe your issue or query.",
  };

  const askNext = () => {
    messages.push({ role: "bot", text: QUESTIONS[escalation.step] });
    persist();
    render();
  };

  const handleEscalationInput = async (text) => {
    escalation.data[escalation.step] = text;

    if (escalation.step === "name") escalation.step = "email";
    else if (escalation.step === "email") escalation.step = "phone";
    else if (escalation.step === "phone") escalation.step = "issue";
    else {
      await fetch(ESCALATION_WEBHOOK_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          sessionId,
          escalation: escalation.data,
          messages,
        }),
      });

      messages.push({
        role: "bot",
        text:
          "Thank you. Your request has been escalated to our support team. Someone will reach out shortly.",
      });

      resetEscalationFlow();
      persist();
      render();
      return;
    }

    askNext();
  };

  /* ================= CHAT ================= */
  const sendMessage = async (text) => {
    messages.push({ role: "user", text });

    if (escalation.active) {
      await handleEscalationInput(text);
      return;
    }

    messages.push({ role: "bot", text: "…" });
    render();

    const res = await fetch(CHAT_WEBHOOK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify([{ sessionId, chatInput: text }]),
    }).then((r) => r.json());

    messages.pop();

    const payload =
      res?.[0]?.output ||
      res?.output ||
      res || {};

    if (payload.escalate === true || payload.escalate === "true") {
      escalation = { active: true, step: "name", data: {} };
      askNext();
      return;
    }

    // ✅ attach quickReplies back
    messages.push({
      role: "bot",
      text: payload.reply || "No response",
      quickReplies: payload.quickReplies || [],
    });

    persist();
    render();
  };

  /* ================= EVENTS ================= */
  bubbleBtn.onclick = () => {
    panel.style.display = panel.style.display === "none" ? "flex" : "none";
    render();
    panel.querySelector("#gio_input").focus();
  };

  panel.querySelector("#gio_close").onclick = () =>
    (panel.style.display = "none");

  panel.querySelector("#gio_send").onclick = () => {
    const input = panel.querySelector("#gio_input");
    const value = input.value.trim();
    if (!value) return;
    input.value = "";
    sendMessage(value);
  };

  panel.querySelector("#gio_input").addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      panel.querySelector("#gio_send").click();
    }
  });

  /* ================= INIT ================= */
  if (!messages.length) {
    messages.push({
      role: "bot",
      text: "Welcome to Drink GIÓ! How can I help you today?",
    });
    persist();
  }

  render();
})();
